/* eslint-disable no-unused-vars */
import { changePasswordAction } from '@store/StaticStore/authSlice'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Formik } from 'formik'

import { validateEmail } from '@utils/validator'
import { useAuth } from '@hooks/useAuth'

type Props = {}

const ForgotPassword: React.FC<Props> = () => {
  const { isSubmitingChangePwd } = useSelector(state => state.auth)
  const dispatch = useDispatch()
  const authInfo = useAuth()

  return (
    <div className="registration-form">
      <div className="login-box">
        <div className="form-icon">
          <img src="/assets/img/GMTS_horizontal_logo.png" alt="" />
        </div>
        <Formik
          key={authInfo?.email}
          initialValues={{ email: authInfo?.email || '' } as TAuthAPI.Body.ForgotPassword}
          validate={values => {
            const errors: { [x in keyof TAuthAPI.Body.ForgotPassword]?: string } = {}
            if (!values.email) {
              errors.email = 'Required'
              if (!validateEmail(values.email)) {
                errors.email = 'メールアドレスを正しく入力してください'
              }
            }

            return errors
          }}
          onSubmit={values => {
            dispatch(changePasswordAction(values))
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleSubmit
          }) => (
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <div className="input-group mb-2">
                  <div className="input-group-prepend">
                    <span className="input-group-text" id="basic-addon1"><i className="fas fa-envelope" /></span>
                  </div>
                  <input
                    value={values.email}
                    onChange={handleChange}
                    name="email"
                    className="form-control"
                    placeholder="Eメール"
                    type="email"
                  />
                </div>
                {errors.email && touched.email && errors.email}
              </div>
              <div className="form-group text-center">
                <button disabled={isSubmitingChangePwd} type="submit" className="btn btn-block create-account">
                  {isSubmitingChangePwd ? 'パスワードの再発行の申請中' : 'パスワードの再発行'}
                </button>
              </div>
            </form>
          )}
        </Formik>
      </div>
    </div>
  )
}

export default ForgotPassword
